import { render, staticRenderFns } from "./NotifAction.vue?vue&type=template&id=6cb7a3b1&"
import script from "./NotifAction.vue?vue&type=script&lang=js&"
export * from "./NotifAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports